import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { DealCard } from "@/components/DealCard";

interface WhatsHotSectionProps {
  hotProducts: any[];
}

export const WhatsHotSection = ({ hotProducts }: WhatsHotSectionProps) => {
  return (
    <section className="py-10 md:py-16">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-bold">What's hot</h2>
          <Link to="/browse">
            <Button variant="outline" size="sm">
              View All <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
        
        <Carousel
          opts={{
            align: "start",
            loop: true,
            dragFree: false,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {hotProducts.map((product) => (
              <CarouselItem key={product.id} className="pl-2 md:pl-4 basis-[70%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <DealCard {...product} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex left-0 h-10 w-10 bg-background border-2 hover:bg-secondary disabled:opacity-50" />
          <CarouselNext className="hidden md:flex right-0 h-10 w-10 bg-background border-2 hover:bg-secondary disabled:opacity-50" />
        </Carousel>
      </div>
    </section>
  );
};